import { useChannelContext } from "@sendbird/uikit-react/Channel/context";
import { logError } from "@src/appV2/lib/analytics";
import { useEffect, useState } from "react";

interface ChannelMetadata {
  facilityName?: string;
  description?: string;
}

export function useChannelMetadata(): ChannelMetadata | undefined {
  const { currentGroupChannel } = useChannelContext();
  const [metadata, setMetadata] = useState<ChannelMetadata | undefined>();

  useEffect(() => {
    if (!currentGroupChannel) {
      setMetadata(undefined);
      return;
    }

    setMetadata(undefined);
    let isCancelled = false;

    async function fetchMetadata(): Promise<void> {
      try {
        const result = await currentGroupChannel!.getAllMetaData();
        if (!isCancelled) {
          setMetadata(result as ChannelMetadata);
        }
      } catch (error: unknown) {
        logError("Failed to fetch clipboard guides channel metadata", { error });
      }
    }

    void fetchMetadata();

    return () => {
      isCancelled = true;
    };
  }, [currentGroupChannel]);

  return metadata;
}
